<template><div class="main">
  <sticky-bar>Direct Link</sticky-bar>
</div></template>
<script>
import StickyBar from './StickyBar'
export default {
  name: 'direct-link',
  components: { StickyBar },
}
</script>
